export enum SidebarItemNavigationType {
  Path = 'Path',
  Link = 'Link',
  Submenu = 'Submenu',
  Noaction = 'Noaction',
}
